import { useLayoutEffect, useRef, useState } from "react";
import InputButton from "../InputButton";

// options format: [{ title: string, value: string, disabled: boolean }]
// title and value are required

function InputButtonsSameSize({
  options = [],
  variant = "white",
  selectedValues = [],
  onClick = () => {},
  containerClassName,
  size,
  trackingName,
  withTracking = true,
}) {
  const buttonRefs = useRef([]);
  function findButtonMinWidth() {
    if (size === "xs") return 32; // $btn-size-xs
    if (size === "sm") return 40; // $btn-size-sm
    if (size === "lg") return 56; // $btn-size-lg

    return 48; // $btn-size-base
  }

  const defaultMinWith = findButtonMinWidth();

  const [largestButtonWidth, setLargestButtonWidth] = useState(defaultMinWith || 0);

  useLayoutEffect(() => {
    const widths = buttonRefs.current.map((ref) => {
      return ref?.offsetWidth || defaultMinWith;
    });

    const maxWidth = widths?.length > 0 ? Math.max(...widths) : defaultMinWith;

    if (maxWidth !== largestButtonWidth) {
      setLargestButtonWidth(maxWidth);
    }

    return () => {
      buttonRefs.current = [];
    };
  }, [options, selectedValues]);

  return (
    <section className={containerClassName}>
      {options.map((option, index) => (
        <InputButton
          ref={(ref) => (buttonRefs.current[index] = ref)}
          key={`${index}-${option.title}`}
          title={option.title}
          subtitle={option.subtitle}
          size={size}
          variant={variant}
          checked={selectedValues.includes(option.value)}
          onClick={() => onClick(option.value)}
          minWidth={largestButtonWidth > defaultMinWith ? `${largestButtonWidth}px` : undefined}
          disabled={option.disabled}
          leftIconName={option.leftIconName}
          rightIconName={option.rightIconName}
          trackingName={trackingName}
          withTracking={withTracking}
        />
      ))}
    </section>
  );
}

export default InputButtonsSameSize;
